module.exports = __webpack_public_path__ + "img/ski3.05824d3a.jpg";